import React from 'react';

import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Col, Modal, Row } from 'antd';
import { deleteFinancialStage } from '../../data/store/account/accountActions';

const ModalDeletePlanStage = ({ accountId, modalDelete, setModalDelete }) => {
  const { t } = useTranslation('');
  const dispatch = useDispatch();

  const { financialPlan } = useSelector((state) => state.accountReducer);

  const handleCloseDelModal = () => {
    setModalDelete(null);
  };

  const handleDelete = () => {
    dispatch(
      deleteFinancialStage({
        accountId,
        planId: financialPlan.id,
        stageId: modalDelete,
        callback: handleCloseDelModal,
      }),
    );
  };

  return (
    <Modal
      width={650}
      className="modal-content-paper"
      open={!!modalDelete}
      onCancel={handleCloseDelModal}
      footer={null}
      zIndex={1600}
    >
      <Row justify="center">
        <Col className="modal-title">{t('MODAL_DELETE_TITLE')}</Col>
      </Row>
      <Row justify="center" className="modal-text-wrapper">
        <Col>
          <p className="modal-delete-text">
            {t('MODAL_DELETE_PLAN_STAGE')}{' '}
            <span className="modal-delete-name">
              {financialPlan?.stages?.find((i) => i.id === +modalDelete)?.name}
            </span>
          </p>
          <p className="modal-delete-text">
            {t('DELETE_PLAN_STAGE_AT')}{' '}
            <span className="modal-delete-name">{financialPlan?.name}</span>
          </p>
        </Col>
      </Row>
      <Row className="modal-advisor-btn-wrapper">
        <Button
          className="modal-action-btn cancel-btn"
          onClick={handleCloseDelModal}
        >
          {t('CANCEL')}
        </Button>
        <Button className="modal-action-btn delete-btn" onClick={handleDelete}>
          {t('DELETE')}
        </Button>
      </Row>
    </Modal>
  );
};

export default ModalDeletePlanStage;

ModalDeletePlanStage.propTypes = {
  accountId: PropTypes.string,
  modalDelete: PropTypes.number,
  setModalDelete: PropTypes.func,
};
